import React from "react";

export default (props) => {
  return (
    <div>
      {props.has_randomization_platform_step_3_surrogate ? (
        <div
          dangerouslySetInnerHTML={{
            __html: props.randomization_platform_step_3_surrogate_content,
          }}
        />
      ) : (
        <div style={{ textAlign: 'justify'}}>
          <h4 align="center">
            Informed Consent Form ACT RCCT
          </h4>
          <table style={{ width: '100%', textAlign: 'left'}}>
            <tbody>
            <tr>
              <td style={{ width: '30%'}} valign="top">
                <b>STUDY TITLE:</b>
              </td>
              <td style={{ width: '70%'}} valign="top">
                Alteplase Compared to Tenecteplase in<br/>
                Patients with Acute Ischemic Stroke:<br/>
                QuICR and OPTIMISE Registry:<br/>
                based Pragmatic Randomized:<br/>
                Controlled Trial (ACT RRCT)
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%'}} valign="top">
                <b>CLINICAL STUDY REGISTRATION NUMBER:</b>
              </td>
              <td style={{ width: '70%'}} valign="top">
                NCT03889249
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%'}} valign="top">
                <b>PRINCIPAL INVESTIGATOR:</b>
              </td>
              <td style={{ width: '70%'}} valign="top">
                Dr. Heather Williams, M.D., BSc, FRCPC<br/>
                CSCN (EMG)<br/>
                Neurologist<br/>
                201-199 Grafton St.<br/>
                Charlottetown, PE C1A 1L2<br/>
                902-629-8872
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%'}} valign="top">
                <b>STUDY SPONSOR:</b>
              </td>
              <td style={{ width: '70%'}} valign="top">
                Bijoy K. Menon M.D., MSc, FRCPC<br/>
                University of Calgary Room 1049A,<br/>
                Foothills Medical Centre 1403, 29th Street<br/>
                NW Calgary, AB, T2N 2T9<br/>
                Phone: 403-944-8107 Fax: 403-283-2270<br/>
                email: Bijoy.Menon@Albertahealthservices.ca<br/>
              </td>
            </tr>
            <tr>
              <td style={{ width: '30%'}} valign="top">
                <b>FUNDER:</b>
              </td>
              <td style={{ width: '70%'}} valign="top">
                1) Heart and Stroke Foundation of Alberta<br/>
                2) Alberta Innovates-Health Solutions<br/>
                3) Canadian Institutes of Health Research<br/>
                4) University of Calgary
              </td>
            </tr>
            </tbody>
          </table>
          <br/>
          <div style={{ borderBottom: '1px solid white'}}></div>
          <br/>
          <h4>
            1. Introduction
          </h4>
          <p>
            <em>
              If you, being the family member or partner, are acting as a representative to give consent for another
              person to participate in this study, “you” throughout this consent form refers to that individual (the
              subject). Your obligation is to try to determine what the individual would do if competent, or if the
              subject’s wishes cannot be determined, what you think is in the person’s best interest.
            </em>
          </p>
          <p>
            You have been invited to take part in a research study. A research study is a way of gathering information
            on a treatment, procedure or medical device or to answer a question about something that is not well
            understood. Taking part in this study is voluntary. It is up to you to decide whether to be in the study or
            not. Before you decide, you need to understand what the study is for, what risks you might take
            and what benefits you might receive. This consent form explains the study.
          </p>
          <p>
            The research team will tell you if there are any study timelines for making your decision.<br/>
            Please ask the research team or the principal investigator to clarify anything you do not understand or would
            like to know more about. Make sure all your questions are answered to your satisfaction before deciding whether
            to participate in this research study.
          </p>
          <p>
            The researchers will:<br/>
            <ul>
              <li>Discuss the study with you.</li>
              <li>Answer your questions.</li>
              <li>Be available during the study to deal with problems and answer questions.</li>
            </ul>
          </p>
          <p>
            You are being asked to stay in this study because you have had an ischemic stroke. This is when a clot blocks a
            blood vessel, reducing the blood supply to a part of your brain. When this happens, the affected part of the
            brain can be damaged, sometimes permanently.
          </p>
          <p>
            If you decide not to take part or if you leave the study early, your usual health care will not be affected.
          </p>
          <h4>
            2. Why is there a need for this study?
          </h4>
          <p>
            Stroke is an emergency where every minute counts. Because of this, you were enrolled in this study by deferral
            of consent. This means that you had either Alteplase or Tenecteplase without first being asked. This process was
            created with experts in research ethics and with stroke patients. This was approved by your hospital’s research
            ethics board.
          </p>
          <p>
            The goal of this study is to compare the drug Alteplase with the trial drug Tenecteplase. Alteplase is the
            existing treatment for stroke (blocked blood vessel in the brain). Tenecteplase is not approved for
            treatment in stroke. It is a treatment for a heart attack (a blocked blood vessel in the heart). This study
            is to decide if patients who receive Tenecteplase do as well as those who receive Alteplase, after their
            stroke.
          </p>
          <p>
            This is a
            <b>Phase III</b>
            <em>Study- The drug is given to even larger groups of people (usually 1,000 or more) to:</em>
            <ul>
              <li><em>confirm its effectiveness</em></li>
              <li><em>monitor side effects</em></li>
              <li><em>compare it to commonly used treatments</em></li>
              <li><em>collect information that will allow the investigational product or test article to be used safely on the
                market</em></li>
            </ul>
          </p>
          <p>
            This study is being done for many reasons. Some of these reasons are listed below:
            <ol>
              <li>New research has shown that tenecteplase may break down the clot in the brain better than alteplase. This is
                because tenecteplase connects to the clot differently than Alteplase.
              </li>
              <li>Tenecteplase is given in a single dose of a drug called a bolus. Alteplase is given in a single bolus
                followed by a 60-minute drip line of drug. This needs a special pump and two separate calculations of the
                dose. This difference in how the drug is given makes tenecteplase easier and <u>possibly</u> safer to give
                than alteplase as there is less math and equipment needed.
              </li>
              <li>Transfer of patients from one hospital to another is easier without the need for pumps as well as faster
                because you don’t need to wait for the 60-minute drip line of drug to finish before transfer.
              </li>
            </ol>
          </p>
          <p>
            Therefore, it is possible that the use of tenecteplase in patients with stroke may result in faster treatment
            and transport, saving time, reducing problems and possibly improving patient results while saving on health care
            costs.
          </p>
          <h4>
            3. What Is Being Tested?
          </h4>
          <p>
            We know that a drug called Alteplase (tPA) can decrease brain damage from a stroke by breaking down the clot in
            the blocked blood vessel. This helps to return normal blood supply to the brain before it becomes permanently
            damaged. Alteplase is the usual treatment for stroke patients. Even with the benefits of Alteplase reducing
            brain damage/disability in stroke patients, there are risks including brain bleeding.
          </p>
          <p>
            Tenecteplase (TNK) is a different clot-busting drug that is similar to Alteplase and is often used for patients
            who have a heart attack. This is where there is a clot blocking a blood vessel in the heart.
          </p>
          <p>
            Health Canada has approved the sale and use of Tenecteplase to treat heart attack. Although they have not
            approved its use for stroke, they have allowed its use in this clinical trial.
          </p>
          <p>
            One half of study participants will receive Alteplase as this is the standard treatment for stroke currently
            available and this group will act as a control group.
          </p>
          <p>
            The other half of study participants will receive Tenecteplase as the study drug. The study has been designed
            this way to directly compare the two drugs, their side effects, and to see which one is the better treatment.
          </p>
          <h4>
            4. How Long Will I Be In The Study?
          </h4>
          <p>
            The length of this study for participants is approximately 3 months or 90 days. The entire study is expected to
            take about 2 years to complete and the results should be known 1-2 years after the study has ended.
          </p>
          <h4>
            5. How Many People Will Take Part In This Study?
          </h4>
          <p>
            It is anticipated that about 1600 people will participate in this study throughout Canada. About
            25-50 people will participate in this study at the Queen Elizabeth Hospital.
          </p>
          <h4>
            6. How Is The Study Being Done?
          </h4>
          <p>
            Participants in this study have been randomly (by chance) placed in one of 2 study groups. Neither you, the
            study staff nor the investigator(s) can influence which group you were assigned. You had a 50% chance of being
            placed in either group. You and the research team will know which group you are in.
          </p>
          <p>
            Group A: Called the Intervention Group had received the drug Tenecteplase as a single dose (called a bolus)
            based on your weight, as soon as possible after randomization
          </p>
          <p>
            Group B: Called the Control Group had received the drug Alteplase via as a single dose (bolus) followed by a
            60-minute drip line of the drug based on your weight as soon as possible after randomization.
          </p>
          <p>
            All patients will receive standard stroke care on a stroke care unit after receiving either drug. While on the
            stroke care unit all tests will be standard tests given to all stroke patients regardless of which drug you
            received.
          </p>
          <p>
            You will be asked to return to the hospital for 1 visit at 3 months (90 days) as standard stroke care follow up.
            You will also be asked to accept 1 phone call at 3 months (90-120 days) for this study.
          </p>
          <h4>
            7. What Will Happen If I Take Part In This Study?
          </h4>
          <p>
            STUDY<br/>
            We have done the following as part of this trial:<br/>
            <ul>
              <li><em>We have given you one of the two drugs A) Alteplase (standard stroke treatment) or B) Tenecteplase
                (study stroke treatment)</em></li>
              <li><em>You have and will continue to receive the same stroke care that all stroke patients receive.</em></li>
            </ul>
          </p>
          <p>
            If you agree to stay in this study, you will be asked to do the following as part of the trial:<br/>
            <ul>
              <li>A follow up visit at 3 months (90 days), would happen as is standard with your stroke doctor.</li>
              <li>There will be a one-time telephone interview with research staff from the University of Calgary/Foothills
                Medical Centre. The phone call will last about 5 minutes. This call will be as close to 90 days as possible,
                to a limit of 120 days based on your schedule. For people who are not fluent in English, the services of an
                interpreter will be offered.
              </li>
              <li>If you are able and interested, we will also ask you to complete an online assessment to find out if there
                are any differences in memory or thinking between the groups of people who got the two drugs. You do not
                have to complete this online assessment to be part of the main study. This assessment will be done at 90-120
                days and/or at 1 year.
              </li>
              <li>After this period (phone call and/or online assessment) is finished, your participation in the study will be
                complete.
              </li>
            </ul>
          </p>
          <p>
            Of course, you may ask not to have further tests done or to participate in any study procedures at any time.
          </p>
          <p>
            It is important that you tell the research team about any treatment therapies, drugs or medicines you are taking
            or wish to take. You must also tell the research team about anything unusual that is happening with your health.
            This includes any medical problems that seem to be getting worse. If you see another doctor or must go to a
            hospital, you should let the doctors know that you are in a research study. You should also tell your own doctor
            as quickly as possible, for your safety.
          </p>
          <h4>
            8. Are There Risks To The Study?
          </h4>
          <p>
            There are risks with this, or any study. To give you the most complete information available, we have listed
            many possible risks, which may appear alarming. We do not want to alarm you but we do want to make sure that if
            you decide to stay in the study, you have had a chance to think about the risks carefully. Please also be aware
            that there may be risks in participating in this study that we do not know about yet.
          </p>
          <p>
            There is a risk that that Tenecteplase may not be as effective in the treatment of stroke as Alteplase.
          </p>
          <p>
            During this study you will have the same number of tests using radiation that are used to diagnose or treat your
            existing medical condition. You will not receive any extra radiation procedures while you are enrolled in this
            study. The procedures will be done using established procedures of this institution and be performed by
            authorized persons.”
          </p>
          <h4>
            DRUG EFFECTS
          </h4>
          <p>
            As the two drugs are chemically similar, Alteplase and Tenecteplase have similar side effects. The major risks
            of Alteplase are:<br/>
            <ol>
              <li>Bleeding (into the brain) risk is about 5%, as per the Safe Implementation of Thrombolysis in Stroke (SITS)
                registry; this is the major side effect. <u>Bleeding into the brain may lead to death.</u></li>
              <li>Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100), but may require
                specific treatment (such as surgery) or a blood transfusion.
              </li>
              <li>Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is easily controlled.
                This risk may occur in one of every 5 patients.
              </li>
              <li>Very rarely, Alteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can lead
                to low blood pressure, airway swelling and obstruction. <u>This could potentially be fatal, but there have
                  been no deaths reported</u> due to allergy with either drug. This reaction can be treated with
                medication.
              </li>
              <li>The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in
                this study after consultation with an expert stroke physician.
              </li>
            </ol>
          </p>
          <p>
            The Major risks for Tenecteplase are:<br/>
            <ol>
              <li>Bleeding (into the brain) risk is about 3-4%, as per recent data; this is the major side effect. <u>Bleeding
                into the brain may lead to death.</u></li>
              <li>Bleeding from the stomach or urinary tract. This is rare (less than 1 chance in 100) but may require
                specific treatment (such as surgery) or a blood transfusion.
              </li>
              <li>Bruising or bleeding from your injection site, nose or gums. Generally, such bleeding is minor and easily
                controlled. This risk may occur in one of every 5 patients.
              </li>
              <li>Very rarely, Tenecteplase can cause a serious allergic reaction (about 1 in 10,000 treatments). This can
                lead to low blood pressure, airway swelling and obstruction. <u>This could potentially be fatal, but there
                  have been no deaths</u> reported due to allergy with either drug. This reaction can be treated with
                medication.
              </li>
              <li>The risk to an unborn child is uncertain. If you are pregnant, you will only be allowed to participate in
                this study after consultation with an expert stroke physician.
              </li>
            </ol>
          </p>
          <p>
            You may notice none, some, or all of these side effects and they may be mild, moderate, or severe. Many side
            effects disappear after treatment is stopped. The principal investigator may prescribe medications to ease the
            discomfort you may experience if any of these side effects occur. If any severe reaction to the study drug
            occurs, the principal investigator may interrupt or discontinue the study drug treatment.
          </p>
          <p>
            The research team will be checking you closely to see if any of these side effects are occurring.
          </p>
          <p>
            There may be side effects that are not yet known. You must tell the research team about any new symptoms you
            experience.
          </p>
          <p>
            The effects or discomforts of tests/procedures that are part of this study but are also part of your normal
            clinical care will be reviewed by your treating doctor.
          </p>
          <h4>
            QUESTIONNAIRES:
          </h4>
          <p>
            You may find the interviews and questionnaires you receive during the course of the study upsetting or
            distressing. You may not like all of the questions that you will be asked. You do not have to answer those
            questions you find too distressing.
          </p>
          <p>
            The study treatment may interfere with medications, both prescribed and over the counter that you are currently
            taking. You should ask the research team if the study treatment could interfere with your medications before
            consenting to be in this study. You should also consult with the research team before taking any new
            medications.
          </p>
          <p>
            You will be told about any new information that might reasonably affect your willingness to continue to
            participate in this study as soon as the information becomes available to the research team.
          </p>
          <h4>
            9. Are There Benefits Of Participating In This Study?
          </h4>
          <p>
            You may or may not benefit directly from participating in this study. However, possible benefits include close
            monitoring of your stroke, general health status and any symptoms that you may experience during the study. Your
            participation may or may not help other people with stroke in the future.
          </p>
          <h4>
            10. Are There Other Choices?
          </h4>
          <p>
            New treatments become available for this sort of condition at different times and in different parts of the
            world. Like many other hospitals, we do not feel it is helpful to test more than one experimental treatment for
            the same condition at the same time in the same person. This could even be dangerous. So, you will not receive
            two experimental treatments at the same time.<br/>
            You are free to seek other opinions or choices in other hospitals or cities if you wish.
          </p>
          <h4>
            11. What Happens at the End of the Study?
          </h4>
          <p>
            The study treatment will be provided to you only during this study and not after the study is over.
          </p>
          <p>
            The study results are expected to be finished months to years after the study ends. A summary will be available
            on&nbsp;
            <a href="http://www.ClinicalTrials.gov" target="_blank" rel="noopener noreferrer">
              http://www.ClinicalTrials.gov
            </a>
          </p>
          <h4>
            12. What Are My Responsibilities?
          </h4>
          <p>
            As a study participant you will be expected to:<br/>
            <ul>
              <li>Follow the directions of the research team;</li>
              <li>Report all medications being taken or that you plan on taking;</li>
              <li>Report any changes in your health to the research team;</li>
              <li>Report any problems that you experience that you think might be related to participating in the study;</li>
            </ul>
          </p>
          <h4>
            13. Can My Participation in this Study End Early?
          </h4>
          <p>
            The study sponsor, the Health PEI Research Ethics Board, Health Canada, and the principal
            investigator have the right to stop patient recruitment or cancel the study at any time.
          </p>
          <p>
            The principal investigator may decide to remove you from this study without your consent for any of the
            following reasons:<br/>
            <ul>
              <li>You do not follow the directions of the research team.</li>
              <li>There is new information that shows that being in this study is not in your best interests.</li>
            </ul>
          </p>
          <p>
            If you are withdrawn from this study, a member of the research team will discuss the reasons with you and plans
            will be made for your continued care outside of the study.
          </p>
          <p>
            You can also choose to end your participation at any time. If you choose to withdraw from this study by
            providing notice to the research team, your decision will have no effect on your current or future medical
            treatment and healthcare. Your health records may be examined in connection with this study or further analyses
            related to it. Your health records will only be made available as described above. However the above agencies,
            including the sponsor, will only look at and use study related records up to the date of your withdrawal from
            the study, except where it is necessary to ensure that the study is scientifically reliable and to report side
            effects associated with the study medication as required by regulatory authorities.
          </p>
          <p>
            Of course, you may request not to have further tests done or to participate in any additional study procedures
            at any time.
          </p>
          <h4>
            14. What About New Information?
          </h4>
          <p>
            It is possible that new information may become available while you are in the study about side effects or a new
            treatment for your condition. You will be told about any other new information that might affect your health,
            welfare, or willingness to stay in the study and will be asked whether you wish to continue taking part in the
            study or not.
          </p>
          <h4>
            15. Will It Cost Me Anything?
          </h4>
          <p>
            <u>Compensation</u><br/>
            You will not have to pay for any study related treatments you take while participating in this study. You may
            need to pay for medications to treat any side effects you may experience as a result of participating in this
            study. Your private health care insurer may not pay for all of these added costs.
          </p>
          <p>
            <u>Research Related Injury</u><br/>
            If you become ill or injured as a direct result of participating in this study, necessary medical treatment will
            be available at no additional cost to you. Your signature on this form only indicates that you have understood
            to your satisfaction the information regarding your participation in the study and agree to participate in the
            study. In no way does this waive your legal rights nor release the principal investigator, the research team,
            the study sponsor or involved institutions from their legal and professional responsibilities.
          </p>
          <h4>
            16. What About My Privacy and Confidentiality?
          </h4>
          <p>Protecting your privacy is an important part of this study and every effort to protect your privacy will be made.
            However, complete privacy cannot be guaranteed. For example, the principal investigator may be required by law
            to allow access to research records. Your family doctor will be told that you are taking part in this study.</p>
          <p>If the results of this study are presented to the public, nobody will be able to tell that you were in the
            study.</p>
          <p>If you decide to stay in this study, the research team will collect personal health information from you and your
            health record. The research team will collect and use only the information they need for this study and to judge
            the safety and usefulness of the study treatment.
          </p>
          <p>
            “Personal health information” is health information about you that could identify you because it includes
            information such as your;<br/>
            <ul>
              <li>Name,</li>
              <li>Address,</li>
              <li>Telephone number,</li>
              <li>Age or month/year of birth (MM/YY),</li>
              <li>Information from the study interviews and questionnaires;</li>
              <li>New and existing medical records, or</li>
              <li>The types, dates and results of various tests and procedures.</li>
            </ul>
          </p>
          <p>
            <u>Access to Records</u><br/>
            Other people may need to look at your personal health information to check that the information collected for
            the study is correct and to make sure the study followed the required laws and guidelines. These people might
            include:<br/>
            <ul>
              <li>Bijoy K. Menon M.D., and its representatives and partner companies as per the title page of this consent
                form;
              </li>
              <li>The Health PEI Research Ethics Board and people working for or with the Health PEI REB
                because they oversee the ethical conduct of research studies within Health PEI
              </li>
              <li>Representatives of Health Canada, who oversee the use of drugs, natural health products and medical devices
                in research in Canada;
              </li>
              <li>When you sign this consent form you give us permission to collect information from the Department of Health
                and Wellness' SHARE Electronic Health Record (which contains laboratory test results, Diagnostic Imaging as
                well as admissions, discharge and transfer records from across the province
              </li>
              <li>When you sign this consent form you give us permission to access your health information for/from various
                registries including OPTIMISE (another study database), and CIHI (another hospital database)
              </li>
            </ul>
          </p>
          <p>
            OPTIMISE collects data from hospitals in Canada including information about when you had your stroke, what
            treatment you had, and how that treatment worked. All data in this database are coded with a unique ID number
            and does not have any information that could identify you. The OPTIMISE data base will be linked to the study
            database discussed in this consent form.
          </p>
          <p>
            CIHI collects data from hospitals in Canada including information about how often Canadians go to the hospital,
            how long they stayed, what types of doctors they saw, and other information about these hospitalizations/
            emergency department (ED) visits. This information is stored in the CIHI clinical administrative databases,
            along with your health care number. Your name is not included in these databases. In order to locate information
            about your past and future hospitalizations or ED visits up until a year after enrolment, which may include
            hospitals other than where you were originally admitted at the time of your stroke, authorized personnel from
            the study hospitals or registries will provide your health care number directly to CIHI solely for the purpose
            of extracting your hospitalization records from its databases. CIHI will then provide these records back to the
            study investigators without the health care number, using an anonymized study identification number. The study
            investigators will add the CIHI data to the study data based on this study identification number.
          </p>
          <p>
            These people will view your study records at this institution and will not take identifying information away
            with them. In order to complete the 90-day telephone follow up, your contact information will be sent to the
            research team in Calgary.
          </p>
          <p>
            <u>Use of Your Study Information</u><br/>
            Any study data about you that is sent outside of the Nova Scotia Health Authority will have a code and will not
            contain your name or address, or any information that directly identifies you except those needed to complete
            the 90-day telephone follow up. Your contact information including your phone number will be sent to the
            research team in Calgary. This will allow them to complete the follow up as discussed in this document.
          </p>
          <p>
            De-identified study data may be transferred to:<br/>
            <ul>
              <li>The sponsor and companies working for and with the sponsor and;</li>
              <li>Regulatory authorities within Canada.</li>
              <li>The 90 day cognitive online assessment will be located on servers in the USA under similar security and
                privacy protocols used by the USA department of defense.
              </li>
            </ul>
          </p>
          <p>
            The sponsor and companies working for and with the sponsor will use the information collected about you during
            the study, only for scientific research and/or drug development purposes. Study data that is sent outside of the
            Nova Scotia Health Authority will be used for the research purposes explained in this consent form.
          </p>
          <p>
            The research team and the other people listed above will keep the information they see or receive about you
            confidential, to the extent permitted by applicable laws. Even though the risk of identifying you from the study
            data is very small, it can never be completely eliminated.
          </p>
          <p>
            The research team will keep any personal health information about you in a secure and confidential location for
            25 years and then destroy it according to NSHA policy. Your personal health information will not be shared with
            others without your permission
          </p>
          <p>
            After your part in the study ends, we may continue to review your health records for safety and data accuracy
            until the study is finished or you withdraw your consent.
          </p>
          <p>
            The REB and people working for or with the REB may also contact you personally for quality assurance purposes.
          </p>
          <p>
            Please be aware that once your data is sent outside of Canada it may be accessed by regulatory authorities in
            other countries who may not have the same privacy laws as we do.
          </p>
          <p>
            <u>Your Access to Records</u><br/>
            You have the right to access, review, and request changes to your study data.<br/>
            A description of this clinical trial will be available on http://www.ClinicalTrials.gov,. This Web site will not
            include information that can identify you. At most, the Web site will include a summary of the results. You can
            search this Web site at any time.
          </p>
          <h4>
            17. Declaration of Financial Interest
          </h4>
          <p>
            The sponsor/funder is reimbursing the principal investigator and/or the principal investigator’s institution to
            conduct this study. The amount of payment is sufficient to cover the costs of conducting the study.
          </p>
          <h4>
            18. What About Questions or Problems?
          </h4>
          <p>
            For further information about the study you may call the principal investigator who is the person in charge of
            this study and/or any other research team member listed below.
          </p>
          <p>
            The principal investigator is Dr. Heather Williams<br/>
            Telephone: (902) 629-8872
          </p>
          <p>
            Your research coordinator is Dr. Heather Williams<br/>
            Telephone: (902) 629-8872
          </p>
          <p>
            If you experience any symptoms or possible side effects or other medical problems, please let the principal
            investigator or research coordinator know as soon as possible.
          </p>
          <p>
            If you can't reach the principal investigator or research coordinator, or it is after regular business
            hours, call <u><b>8-1-1</b></u> for advice or present to your nearest hospital emergency department.
          </p>
          <p>
            Please call the principal investigator or research coordinator the next business day to tell them
            about the possible side effects or other medical problems you experienced.
          </p>
          <h4>
            19. What Are My Rights?
          </h4>
          <p>
            You have the right to all information that could help you make a decision about staying in this study. You also
            have the right to ask questions about this study and your rights as a research participant, and to have them
            answered to your satisfaction before you make any decision. You also have the right to ask questions and to
            receive answers throughout this study. You have the right to withdraw your consent at any time.
          </p>
          <p>
            If you have questions about your rights as a research participant, and/or concerns or complaints about this
            research study, you can contact the Health PEI Research Ethics Board at (902) 569-0576 or <u>reb@ihis.org</u>
          </p>
          <p>
            You are providing consent to stay in the study for ongoing data collection. The administration of either
            Alteplase or Tenecteplase cannot be undone. If you decide not to consent, data collected up until this point
            will be retained. You will not be contacted in the future. You may also withdraw consent for further contact but
            continue follow-up via health record linkage.
          </p>
          <p>
            In the next part you will be asked if you agree (consent) to stay in this study. If the answer is “yes”, please
            sign the form.
          </p>
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ConsentTypePei/Texts/SurrogateElectronicText.js